var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"route-view-box"},[_c('div',{staticClass:"route-view-box-left"},[_c('CategoriesMenu')],1),_c('div',{staticClass:"route-view-box-right"},[_c('router-view',{key:_vm.$route.fullPath})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }